webpackJsonp([89804516164238],{

/***/ 1210:
/***/ (function(module, exports) {

	module.exports = {"pathContext":{"name":"ArBreakdown","kind":"ENUM","type":"OBJECT","fields":null,"description":null,"enumValues":[{"deprecationReason":null,"description":"Breakdown by client/location","isDeprecated":false,"name":"CLIENT"},{"deprecationReason":null,"description":"Breakdown by order","isDeprecated":false,"name":"ORDER"},{"deprecationReason":null,"description":"Breakdown by organization","isDeprecated":false,"name":"ORG"}],"possibleTypes":null}}

/***/ })

});


// WEBPACK FOOTER //
// path---enum-ar-breakdown-1e310ba26ad1c223708d.js